<script setup lang="ts">
type Props = {
  header?: string
  items: Article[]
  query?: Record<string, any>
}

const props = withDefaults(defineProps<Props>(), { header: '' })

const app = useNuxtApp()
const route = useRoute()

const pageData = { term: null }

const onClickQuery = (term: string | undefined) => {
  navigateTo(
    {
      name: 'index',
      query: { term },
    },
  )
}

const queryForLink = () => {
  let term = undefined
  let sort = undefined

  if (pageData.term === 'in') {
    term = 'in'
    sort = 'open_date'
  } else if (pageData.term === 'end') {
    term = 'end'
    sort = 'term_to'
  } else if (pageData.term === 'start') {
    term = 'start'
    sort = 'term_from'
  } else {
    sort = 'pv_last_week'
  }

  return {
    term: term,
    sort: sort,
  }
}

const initPage = () => {
  if (route.query.term) {
    pageData.term = route.query.term
  } else {
    pageData.term = 'in'
  }
}
initPage()
</script>

<template>
  <div class="p-topEventSection">
    <div
      class="c-header fadeInAndMoveTop"
    >
      <TopSectionHeader
        v-bind:header="header"
      />
    </div>
    <div
      class="c-toolBar"
    >
      <div
        class="c-toolBar_list"
      >
        <div
          class="c-toolBar_list_item"
        >
          <v-btn
            class="c-toolBar_list_item_button"
            v-bind:class="{ 'is-select': pageData.term === 'all' }"
            variant="text"
            v-on:click="onClickQuery('all')"
          >
            すべて
          </v-btn>
        </div>
        <div
          class="c-toolBar_list_item"
        >
          <v-btn
            class="c-toolBar_list_item_button"
            v-bind:class="{ 'is-select': pageData.term === 'in' }"
            variant="text"
            v-on:click="onClickQuery(undefined)"
          >
            開催中
          </v-btn>
        </div>
        <div
          class="c-toolBar_list_item"
        >
          <v-btn
            class="c-toolBar_list_item_button"
            v-bind:class="{ 'is-select': pageData.term === 'end' }"
            variant="text"
            v-on:click="onClickQuery('end')"
          >
            もうすぐ終了
          </v-btn>
        </div>
        <div
          class="c-toolBar_list_item"
        >
          <v-btn
            class="c-toolBar_list_item_button"
            v-bind:class="{ 'is-select': pageData.term === 'start' }"
            variant="text"
            v-on:click="onClickQuery('start')"
          >
            もうすぐ開始
          </v-btn>
        </div>
      </div>
      <div
        class="c-toolBar_list_item_spacer c-pc-only"
      />
    </div>
    <div
      class="c-recommendList"
    >
      <template
        v-for="(item, index) in items"
        v-bind:key="item.id"
      >
        <EventItem
          v-bind:item="item"
          v-bind:show-label="true"
        />
        <template
          v-if="index === 3 && app.$device.isMobile"
        >
          <span
            v-bind:key="'bannerSP' + index"
            class="c-listAdvertise"
          >
            <!-- <div
              v-if="topAdSp && topAdSp.body"
              class="c-listAdvertise_advertiseCms c-advertise"
              v-html="topAdSp.body"
            /> -->
            <!--
            <div
              class="c-listAdvertise_advertise c-advertise"
            >
              <adsbygoogle
                ad-slot="9530995886"
                ad-format="auto"
              ></adsbygoogle>
            </div>
            -->
          </span>
        </template>
        <template
          v-else-if="index === 5"
        >
          <span
            v-if="app.$device.isMobile"
            v-bind:key="'bannerSP' + index"
            class="c-listAdvertise"
          >
            <!--
            <div
              class="c-listAdvertise_advertise c-advertise"
            >
              <adsbygoogle
                ad-slot="5687953794"
                ad-format="auto"
              ></adsbygoogle>
            </div>
            -->
          </span>
          <span
            v-else
            v-bind:key="'bannerPC' + index"
            class="c-listAdvertise"
          >
            <!-- <div
              v-if="topAdPc && topAdPc.body"
              class="c-listAdvertise_advertiseCms c-advertise"
              v-html="topAdPc.body"
            /> -->
            <!--
            <div
              class="c-listAdvertise_advertise c-advertise"
            >
              <adsbygoogle
                ad-slot="7741488425"
                ad-format="auto"
              ></adsbygoogle>
            </div>
            <div
              class="c-listAdvertise_advertise c-advertise"
            >
              <adsbygoogle
                ad-slot="7612157228"
                ad-format="auto"
              ></adsbygoogle>
            </div>
            -->
          </span>
        </template>
      </template>
    </div>

    <div class="c-button">
      <ArrowLink
        v-bind:to="{ name: 'article', params: { article: 'event' }, query: queryForLink() }"
        label="もっとみる"
        bold
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive" as responsive;

.p-topEventSection {
  position: relative;
  width: var(--g_max_content_width);

  @include responsive.mq_down(sp) {
    width: 100%;
  }

  .c-pc-only {
    display: none;
  }

  .c-headerWrapper {
    @include responsive.mq_down(sp) {
      min-height: auto !important;
    }
  }

  .c-toolBar {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 15px;

    @include responsive.mq_down(sp) {
      display: block;
      box-sizing: border-box;
      margin-top: 10px;
      padding: 0;
    }

    &_icon {
      color: var(--color_primary_link);
    }

    &_col {
      // display: flex;
      display: none;
      color: var(--g_color_text_010101 !important);
      font-family: var(--g_font_family_NotoSansCJKjp);
      font-size: 16px;
      font-weight: bold;

      @include responsive.mq_down(sp) {
        margin-bottom: 22px;
      }

      &_dropDown {
        width: 120px;

        @include responsive.mq_down(sp) {
          flex-basis: 120px;
          max-width: 120px;
        }
      }

      .v-overflow-btn .v-select__slot {
        @include responsive.mq_down(sp) {
          height: 30px;
        }
      }
    }

    &_list {
      display: flex;
      flex: auto;
      align-items: center;
      justify-content: flex-end;

      @include responsive.mq_down(sp) {
        flex-wrap: wrap;
        justify-content: center;
      }

      &_item {
        display: flex;

        &:first-of-type {
          &::before {
            content: "";
            display: inline-block;
            width: 2px;
            height: 24px;
            background-color: #ddd;
          }
        }

        &::after {
          content: "";
          display: inline-block;
          width: 2px;
          height: 24px;
          background-color: #ddd;
        }

        &_button {
          min-width: 136px !important;
          max-height: 24px;
          color: var(--color_text_base !important);
          font-family: var(--g_font_family_NotoSansCJKjp);
          font-size: 14px !important;

          @include responsive.mq_down(sp) {
            min-width: auto !important;
            padding: 0 5px !important;
          }

          &.is-select {
            :deep(.v-btn__content) {
              font-weight: bold !important;
            }
          }
        }
      }
    }
  }

  .c-recommendList {
    display: flex;
    position: relative;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 100%;
    margin-top: 10px;

    @include responsive.mq_down(sp) {
      display: block;
      margin-top: 10px;

      :deep(.c-eventItem:nth-of-type(n + 7)) {
        display: none;
      }
    }
  }

  .c-listAdvertise {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;

    &.is-onlyPC {
      @include responsive.mq_down(sp) {
        display: none;
      }
    }

    &.is-onlySP {
      display: none;

      @include responsive.mq_down(sp) {
        display: flex;
      }
    }

    &_advertise {
      width: 334px;

      // height: 280px;
      margin: 60px 15px 30px;

      @include responsive.mq_down(sp) {
        width: 100%;
        max-width: 334px;
        margin: 30px 0 0;
      }
    }

    &_advertiseCms {
      width: 334px;
      height: auto;
      margin: 60px 15px 30px;

      @include responsive.mq_down(sp) {
        width: 100%;
        max-width: 334px;
        height: auto;
        margin: 30px 0 0;
      }
    }
  }

  .c-button {
    display: flex;
    justify-content: center;
    margin-top: 40px;

    @include responsive.mq_down(sp) {
      margin-top: 30px;
    }

    &_next {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 200px !important;
      height: 48px !important;
      background-color: #fff;
      color: var(--color_primary_link);
      font-family: var(--g_font_family_SawarabiGothic);
      font-size: 14px;

      // border: solid 2px #c5c6c7;
      // border-radius: 6px;
      font-weight: 700;

      @include responsive.mq_down(sp) {
        width: 170px !important;
        height: 40px !important;
        font-size: 14px;
      }

      .v-icon {
        color: var(--color_primary_link);

        @include responsive.mq_down(sp) {
          font-size: 20px;
        }
      }

      > span {
        font-weight: 700;
      }

      &:hover {
        text-decoration: none;

        span {
          text-decoration: underline;
        }
      }
    }
  }

  &_attachment {
    position: absolute;
    top: 45%;
    left: -100px;
    width: 40px;
    height: 40px;
    padding: 0;
    border-color: var(--color_primary_link !important);
    background-color: var(--color_primary_link);

    &_icon {
      transform: rotate(45deg);
      color: var(--g_color_icon_white !important);
    }
  }
}

@keyframes fadeInToTop {
  0% {
    top: 75px;
    opacity: 0;
  }

  50% {
    top: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
